import React from 'react';
import {
  countMembersByFilter,
  MEMBER_STATUS_FILTER_LABELS,
  type MemberStatusFilter,
} from '../utils/memberFilter';
import type { LscMember } from '../types';

interface MemberStatusFilterBarProps {
  members: LscMember[];
  value: MemberStatusFilter;
  onChange: (filter: MemberStatusFilter) => void;
}

const FILTER_ORDER: MemberStatusFilter[] = ['current', 'pending_link', 'inactive', 'all'];

const MemberStatusFilterBar: React.FC<MemberStatusFilterBarProps> = ({
  members,
  value,
  onChange,
}) => {
  const counts = countMembersByFilter(members);

  return (
    <div
      className="flex flex-wrap gap-2"
      data-testid="member-status-filter-bar"
      role="tablist"
      aria-label="Member status filters"
    >
      {FILTER_ORDER.map((filter) => {
        const selected = value === filter;
        return (
          <button
            key={filter}
            type="button"
            role="tab"
            aria-selected={selected}
            className={
              selected
                ? 'rounded-full border border-primary-500 bg-primary-500/15 px-3 py-1.5 text-sm text-primary-200'
                : 'rounded-full border border-secondary-700 px-3 py-1.5 text-sm text-secondary-300 hover:border-secondary-500 hover:text-white'
            }
            onClick={() => onChange(filter)}
            data-testid={`member-status-filter-${filter}`}
          >
            {MEMBER_STATUS_FILTER_LABELS[filter]} ({counts[filter]})
          </button>
        );
      })}
    </div>
  );
};

export default MemberStatusFilterBar;
